import { useId, useMemo } from 'react';

import { cn } from '@/shared/ui/cn';

import { prepareLuyArt } from './luy-art';
import available from './luy-available.svg?raw';

/** O rosto do Luy (decorativo). `animated`: respira e pisca; parado com `prefers-reduced-motion`. */
export function LuyMark({ className, animated = true }: { className?: string; animated?: boolean }) {
  const raw = useId();
  const prefix = `luy${raw.replace(/[^a-zA-Z0-9]/g, '')}`;
  const html = useMemo(() => ({ __html: prepareLuyArt(available, prefix) }), [prefix]);
  return <span aria-hidden className={cn('uyzy-luy inline-block shrink-0', animated && 'uyzy-luy-alive', className)} dangerouslySetInnerHTML={html} />;
}
